import React from 'react';
import { Routes, Route } from 'react-router-dom';
import { AuthProvider } from './AuthContext';
import PrivateRoute from './PrivateRoute';
import LoginForm from './pages/LoginForm';
import Home from './pages/Home';
import YojanaTable from './pages/YojanaTable';
import Tahasil from './pages/Tahasil';
import YojnaPage from './pages/YojnaPage';
import EOfficeTable from './pages/EOfficeTable';
import ApaleSarkarTable from './pages/ApaleSarkarTable';
import LokaadalatTable from './pages/LokaadalatTable';
import StaticTable from './pages/StaticTable';
import TakararPranaliForm from './pages/TakrarPranaliForm';
import TakrarPranaliData from './pages/TakrarPranaliData';
import SearchComponent from './pages/SearchTakrar';
import TopBarStatic from './pages/TopBarStatic';
import { XDChart } from './pages/XDChart';
import Cardsss from './pages/CardData';
import Chartsss from './pages/Chart';
import VisitPages from './pages/VisitPage';
import UserTakrar from './pages/UserTakrar';


const App = () => {
  return (
    <AuthProvider>
      <Routes>
        <Route path="/" element={<UserTakrar />} />
        <Route path="/takrar-pranali-form" element={<TakararPranaliForm />} />
        <Route path="/takrar-pranali" element={<TakrarPranaliData />} />
        <Route path="/takrar-status" element={<SearchComponent />} />
        <Route path="/topBar-static" element={<TopBarStatic />} />
        <Route path="/login" element={<LoginForm />} />
        <Route path="/home" element={<PrivateRoute element={<Home />} />} />
        <Route path="/tahasil" element={<PrivateRoute element={<Tahasil />} />} />
        <Route path="/yojnaPage" element={<PrivateRoute element={<YojnaPage />} />} />
        <Route path="/yojnaPage/yojnaTable" element={<PrivateRoute element={<YojanaTable />} />} />
        <Route path="/chart" element={<PrivateRoute element={<Chartsss />} />} />
        <Route path="/cards" element={<PrivateRoute element={<Cardsss />} />} />
        <Route path="/XDchart" element={<PrivateRoute element={<XDChart />} />} />
        <Route path="/visit" element={<PrivateRoute element={<VisitPages />} />} />
        <Route path="/eoffice" element={<PrivateRoute element={<EOfficeTable />} />} />
        <Route path="/apalesarkar" element={<PrivateRoute element={<ApaleSarkarTable />} />} />
        <Route path="/lokaadalat" element={<PrivateRoute element={<LokaadalatTable />} />} />
        <Route path="/table" element={<PrivateRoute element={<StaticTable />} />} />
      </Routes>
    </AuthProvider>
  );
};

export default App;
